import { Suspense } from 'react';
import dynamic from 'next/dynamic';

import { SectionDivider } from '~/components/SectionDividor';
import MarketCategory from '~/domains/mmp/MarketCategory';

import { HomeCampaignSection } from './HomeCampaignSection';
import { HomeShowcases } from './HomeShowcaseList';
import MarketCardBannerWithFloating from './MarketCardBannerWithFloatingContainer';
import MarketHomeFrequently from './MarketHomeFrequently';
import RecommendKeywords from './RecommendKeywords';
import { TaxEaseEntry } from './TaxEaseEntry';

const DynamicMarketHomeAfterRenderSection = dynamic(
  () => import('./MarketHomeAfterRenderSection'),
);

const HomeMainContents = () => {
  return (
    <>
      <div className="h-[52px]" />
      <TaxEaseEntry />
      <RecommendKeywords />
      <MarketCardBannerWithFloating />
      <HomeShowcases />
      <MarketCategory />
      <MarketHomeFrequently />
      <SectionDivider />
      <HomeCampaignSection />
      <SectionDivider />
      <Suspense fallback={<></>}>
        <DynamicMarketHomeAfterRenderSection />
      </Suspense>
    </>
  );
};

export default HomeMainContents;
